import { React, Fragment } from '../lib/imports';
import { Divider } from '../components';

import HowTo from '../howTo/HowTo';
import PrizeList from '../prizeList/PrizeList';
import Streaks from '../streaks/Streaks';
import Challenges from '../challenges/Challenges';

const GameInfo = () => (
  <>
    <HowTo />
    <PrizeList />
    <Streaks />
    <Challenges />
    <Divider />
  </>
);

export default GameInfo;
